<template>
  <div>
    <v-card elevation="0">
      <v-data-table
        :loading="loading"
        :items="parkingWarnings"
        :headers="headers"
        :items-per-page="5"
      />
    </v-card>

    <v-divider />

    <div class="mt-4 pb-4 d-flex justify-center">
      <v-btn color="primary" depressed @click="openWarningDialog">
        <v-icon left>mdi-plus</v-icon>
        Új figyelmeztetés
      </v-btn>
    </div>

    <v-dialog
      v-if="dialog"
      :value="true"
      persistent
      max-width="640px">
      <v-card>
        <v-card-title>
          Új parkolási figyelmeztetés
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p>Ez a művelet nem visszavonható! A végrehajtás befejezéséhez kattintson a figyelmeztetés gombra!</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="warning" @click="createWarning">Figyelmeztetés</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default{
  data() {
    return {
      loading: false,
      dialog: false,
      parkingWarnings: [],
      errors: {},
      headers: [
        { text: 'Dátum', value: 'created' },
        { text: 'Adminisztrálta', value: 'admin.name', align: 'start', sortable: false },
      ]
    }
  },

  methods:{
    openWarningDialog() {
      this.dialog = true;
    },

    async fetchParkingWarnings() {
      this.loading = true;
      try {
        const response = await this.$http.get('parking-warnings/list', {
          params: { card_id: this.$route.params.id }
        });
        this.parkingWarnings = response.parking_warnings;
      } catch (error) {
        console.error('Error fetching parking warnings:', error);
      } finally {
        this.loading = false;
      }
    },

    async createWarning() {
      this.loading = true;
      try {
        await this.$http.post('parking-warnings/create', {
          card_id: this.$route.params.id,
          created: new Date().toLocaleString('hu-HU', { timeZone: 'Europe/Budapest' }),
        });
        this.$dialog.notify.success('Figyelmeztetés sikeresen létrehozva!');
        this.dialog = false;
        this.warningReason = '';
        this.fetchParkingWarnings();
      } catch (error) {
        console.error('Error creating parking warning:', error);
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.fetchParkingWarnings();
  },
}
</script>